import React from "react";
import PageShell from "../components/PageShell";
import PageHero from "../components/PageHero";
import Services from "../components/Services";
import CallToAction from "../components/CallToAction";

export default function ServicesPage() {
  return (
    <PageShell>
      <PageHero
        eyebrow="◇ Services"
        title="What we build."
        accent="build."
        kicker="Three deep capabilities, one studio. We don't dabble — we ship production-grade software, intelligent automation and defensible security for ambitious teams."
      />
      <Services />
      <CallToAction
        eyebrow="◇ Engage"
        title="Have one of these on your plate?"
        body="The fastest way to find out if we're a fit is a 30-minute working call."
        ctaLabel="Book a call"
      />
    </PageShell>
  );
}
